var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c(
      "div",
      [
        _vm.prev && _vm.currPageNum !== 1
          ? _c(
              "el-button",
              {
                attrs: {
                  icon: "el-icon-arrow-left",
                  size: "mini",
                  type: "primary",
                },
                on: { click: _vm.prevClick },
              },
              [_vm._v(" 上一页 ")]
            )
          : _vm._e(),
        _vm.currPageNum !== _vm.totalPageNum
          ? _c(
              "el-button",
              {
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.nextClick },
              },
              [
                _vm._v(" 下一页"),
                _c("i", { staticClass: "el-icon-arrow-right el-icon--right" }),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _c("div", { staticStyle: { "text-align": "center" } }, [
      _vm.currPage
        ? _c("span", { staticClass: "desc-text" }, [
            _vm._v("第" + _vm._s(_vm.currPageNum) + "页，"),
          ])
        : _vm._e(),
      _vm.totalPage
        ? _c("span", { staticClass: "desc-text" }, [
            _vm._v("共" + _vm._s(_vm.totalPageNum) + "页"),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }